// Sentry service file to allow adding user context to sentry events
import * as Sentry from "@sentry/react";

export const sentryService = {
  // Deliberately narrower than the full user object: only the id is sent to
  // Sentry (a third-party processor). This also stops shipping email, not
  // just the newly-added phone fields.
  setUserContext: (user) => Sentry.setUser(user ? { id: user.id } : null),
  captureException: (error) => Sentry.captureException(error),
  setTag: (key, value) => Sentry.setTag(key, value)
}